import moment from 'moment';
import { Moment } from 'moment';
import { Dispatch, SetStateAction } from 'react';
import './dates.scss';

function Dates({
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    quickDateSelect
} : {
    dateFrom: Moment,
    setDateFrom: Dispatch<SetStateAction<Moment>>,
    dateTo: Moment,
    setDateTo: Dispatch<SetStateAction<Moment>>,
    quickDateSelect: (id: number) => void
}) {
    return (
        <div className="filters-menu-section-body">
            <div className="input-group date-from">
                <input type="date" value={dateFrom.format("YYYY-MM-DD")} onChange={e => setDateFrom(moment(e.currentTarget.value))} />
            </div>
            <span>-</span>
            <div className="input-group">
                <input type="date" value={dateTo.format("YYYY-MM-DD")} onChange={e => setDateTo(moment(e.currentTarget.value))} />
            </div>
            <div className="quick-dates">
                <span onClick={() => quickDateSelect(1)} >Today</span>
                <span onClick={() => quickDateSelect(2)}>Yesterday</span>
                <span onClick={() => quickDateSelect(3)}>Last 2 Days</span>
                <span onClick={() => quickDateSelect(4)}>Last 7 Days</span>
                <span onClick={() => quickDateSelect(5)}>Last 14 Days</span>
                <span onClick={() => quickDateSelect(6)}>Last 30 Days</span>
                <span className="quick-date-2" onClick={() => quickDateSelect(7)}>This Month</span>
                <span className="quick-date-2" onClick={() => quickDateSelect(8)}>Last Month</span>
            </div>
        </div>
    )
}

export default Dates;